import { SearchHintsEffects } from './search-hints.effects';
import { SolrSearchEffects } from './solr-search.effects';

export const effects: any[] = [SolrSearchEffects, SearchHintsEffects];

export * from './solr-search.effects';
